import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isMetalCore, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidResistPrint = (values: EstimateValues, resistPrint?: string) => {
  switch (resistPrint) {
    case ESTIMATE_CONSTANT.塗布する面.両面に塗る.value:
    case ESTIMATE_CONSTANT.塗布する面["パターン面とは逆の面に塗る(Ln面に塗る)"].value:
      return isRigid(values) || isMetalCore(values)
    case ESTIMATE_CONSTANT.塗布する面["パターン面と同じ面に塗る(L1面に塗る)"].value:
    case ESTIMATE_CONSTANT.塗布する面.塗らない.value:
      return true
    default:
      return false
  }
}

export default isValidResistPrint
